import React, {Component} from 'react';
import { Masthead, Heading } from '@xo-union/tk-ui-masthead';
import { compose } from '@xo-union/react-css-modules';
import styles from './styles.css'

export default class HeroSection extends Component {
  render() {
    return (
      <Masthead classes={compose({ 'wrapper': styles['wrapper'] })}
                size={ this.props.size } 
                heading={ <Heading>{ this.props.headline }</Heading> }
                copy={ this.props.subtitle } />
    )
  }
}
